import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-5b631bbf"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "link" };
var _hoisted_2 = { class: "link__text" };
var _hoisted_3 = { class: "link" };
var _hoisted_4 = { class: "link__text" };
var _hoisted_5 = {
    key: 0,
    class: "absolute top-1 ml-6 rounded-full px-1 bg-primary-500 text-xs text-white font-medium"
};
var _hoisted_6 = { class: "link__text" };
var _hoisted_7 = { class: "link" };
var _hoisted_8 = { class: "link__text" };
var _hoisted_9 = { class: "link__text" };
import { computed } from 'vue';
import { planFeatures } from '@common/utils/Plans';
import { canUseFeature } from '@common/modules/school';
import { AuthModalStore } from '@student/modules/store';
import { ChatStore } from '@common/stores';
import Auth from '@common/modules/auth';
import ELink from '@common/ui/ELink.vue';
import EAvatar from '@common/ui/EAvatar/EAvatar.vue';
import { isIOSApp } from '@common/utils/MobileApp';
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseMobileMenu',
    setup: function (__props) {
        var t = useI18n().t;
        var chatVisible = computed(function () { return !ChatStore.hidden; });
        var totalUnreadMessages = computed(function () { return ChatStore.totalUnreadMessages; });
        var canUseChat = computed(function () { return canUseFeature(planFeatures.CHAT_FEATURE_CODE); });
        var user = computed(function () { return Auth.getUser(); });
        var login = function () {
            hideChat();
            AuthModalStore.showLogin();
        };
        var hideChat = function () {
            ChatStore.hide();
        };
        var isIOS = isIOSApp();
        var toggleChat = function () {
            ChatStore.toggle();
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[
                        { 'base-mobile-menu-ios': _unref(isIOS) }
                    ], "base-mobile-menu fixed bottom-0 left-0 w-full bg-white shadow-custom flex lg:hidden"])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(ELink, {
                        "href-to": { name: 'schoolCatalog' },
                        "link-class": [
                            {
                                'link--chat-visible': chatVisible.value
                            }
                        ],
                        class: "flex flex-col justify-start flex-grow items-center",
                        onClick: hideChat
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "w-5 h-5",
                                icon: "bicolor/courses"
                            }),
                            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('menu.catalogCourses')), 1)
                        ]; }),
                        _: 1
                    }, 8, ["link-class"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(ELink, {
                        "href-to": { name: 'library' },
                        "link-class": [
                            {
                                'link--chat-visible': chatVisible.value
                            }
                        ],
                        class: "flex flex-col justify-start flex-grow items-center",
                        onClick: hideChat
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "w-5.5 h-5.5",
                                icon: "bicolor/book"
                            }),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('menu.library')), 1)
                        ]; }),
                        _: 1
                    }, 8, ["link-class"])
                ]),
                (canUseChat.value && !_unref(Auth).isGuest())
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([[
                                {
                                    'link--chat-visible': chatVisible.value
                                }
                            ], "link link--chat"]),
                        onClick: toggleChat
                    }, [
                        (totalUnreadMessages.value > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(totalUnreadMessages.value), 1))
                            : _createCommentVNode("", true),
                        _createVNode(_component_e_icon, {
                            class: "w-5 h-5",
                            icon: "bicolor/chat"
                        }),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('menu.chat')), 1)
                    ], 2))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                    (!_unref(Auth).isGuest())
                        ? (_openBlock(), _createBlock(ELink, {
                            key: 0,
                            class: _normalizeClass([[
                                    {
                                        'link--chat-visible': chatVisible.value
                                    }
                                ], "flex flex-col justify-start flex-grow items-center"]),
                            "href-to": { name: 'profile' },
                            onClick: hideChat
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(EAvatar, {
                                    class: _normalizeClass([[
                                            user.value.avatar && 'group-hover:border-dark/30'
                                        ], "user-avatar"]),
                                    name: user.value.name || user.value.email,
                                    primary: false,
                                    src: user.value.avatar,
                                    mobile: ""
                                }, null, 8, ["class", "name", "src"]),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('menu.profile')), 1)
                            ]; }),
                            _: 1
                        }, 8, ["class"]))
                        : _createCommentVNode("", true)
                ]),
                (_unref(Auth).isGuest())
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass([[
                                {
                                    'link--chat-visible': chatVisible.value
                                }
                            ], "link"]),
                        onClick: login
                    }, [
                        _createVNode(_component_e_icon, {
                            class: "w-5 h-5 mr-2",
                            icon: "login"
                        }),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('menu.login')), 1)
                    ], 2))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
